import { Grid2 as Grid, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { PlusIcon } from 'framework/ui/mui-builder';
import { ProjectSectionAccordion } from 'domain/shared/newProject';
import { ClientPortalTaskComment } from '../../types';
import CommentsList from './CommentsList';
import { useCommentsSectionState } from './useCommentsSectionState';
import { CLIENT_PORTAL_TASK_STATUSES } from 'domain/shared/clientPortal';

type CommentsSectionProps = {
  projectId: string;
  taskId: string;
  initialComments: ClientPortalTaskComment[];
  refetchComments: () => Promise<unknown>;
  taskStatus?: string;
};

const CommentsSection = ({ projectId, taskId, initialComments, refetchComments, taskStatus }: CommentsSectionProps) => {
  const commentsState = useCommentsSectionState({
    initialComments,
    projectId,
    taskId,
    refetchComments,
  });
  const isReadonly =
    taskStatus === CLIENT_PORTAL_TASK_STATUSES.CANCEL || taskStatus === CLIENT_PORTAL_TASK_STATUSES.COMPLETED;

  const renderActions = () => {
    if (commentsState.isAddingComment || isReadonly) {
      return null;
    }

    return (
      <IconButton sx={{ p: 0, ml: 1 }} onClick={commentsState.openCreateForm}>
        <PlusIcon />
      </IconButton>
    );
  };

  return (
    <ProjectSectionAccordion
      title={
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            pl: 2,
            gap: { xs: 4, md: 16 },
          }}
        >
          <Grid size={6}>
            <Typography color="primary" variant="h4" pl={2}>
              Comments
            </Typography>
          </Grid>
          <Grid size="auto" display="flex" alignItems="center">
            {renderActions()}
          </Grid>
        </Grid>
      }
      sx={{ width: { md: '50%', sm: '100%' } }}
      defaultExpanded
    >
      <CommentsList comments={commentsState.comments} actions={commentsState.actions} isReadonly={isReadonly} />
    </ProjectSectionAccordion>
  );
};
export default CommentsSection;
